window.back=function(){
	history.go(-1)
}



// WEBPACK FOOTER //
// ./src/assets/js/nativeJsBridge.js